"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayTriggerPlacementType = void 0;
exports.default = OverlayTrigger;
exports.triggerType = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _OverlayTrigger2 = _interopRequireDefault(require("react-bootstrap/OverlayTrigger"));

var _excluded = ["rootClose"];

function OverlayTrigger(props) {
  var rootClose = props.rootClose,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger2.default, (0, _extends2.default)({
    rootClose: rootClose
  }, remainingProps));
}

OverlayTrigger.TRIGGER_CLICK = 'click';
OverlayTrigger.TRIGGER_HOVER = 'hover';
OverlayTrigger.TRIGGER_FOCUS = 'focus';

var triggerType = _propTypes.default.oneOf([OverlayTrigger.TRIGGER_CLICK, OverlayTrigger.TRIGGER_HOVER, OverlayTrigger.TRIGGER_FOCUS]);

exports.triggerType = triggerType;
OverlayTrigger.AUTO_START = 'auto-start';
OverlayTrigger.AUTO = 'auto';
OverlayTrigger.AUTO_END = 'auto-end';
OverlayTrigger.TOP_START = 'top-start';
OverlayTrigger.TOP = 'top';
OverlayTrigger.TOP_END = 'top-end';
OverlayTrigger.BOTTOM_START = 'bottom-start';
OverlayTrigger.BOTTOM = 'bottom';
OverlayTrigger.BOTTOM_END = 'bottom-end';
OverlayTrigger.RIGHT_START = 'right-start';
OverlayTrigger.RIGHT = 'right';
OverlayTrigger.RIGHT_END = 'right-end';
OverlayTrigger.LEFT_START = 'left-start';
OverlayTrigger.LEFT = 'left';
OverlayTrigger.LEFT_END = 'left-end';

var OverlayTriggerPlacementType = _propTypes.default.oneOf([OverlayTrigger.AUTO_START, OverlayTrigger.AUTO, OverlayTrigger.AUTO_END, OverlayTrigger.TOP_START, OverlayTrigger.TOP, OverlayTrigger.TOP_END, OverlayTrigger.BOTTOM_START, OverlayTrigger.BOTTOM, OverlayTrigger.BOTTOM_END, OverlayTrigger.RIGHT_START, OverlayTrigger.RIGHT, OverlayTrigger.RIGHT_END, OverlayTrigger.LEFT_START, OverlayTrigger.LEFT, OverlayTrigger.LEFT_END]);

exports.OverlayTriggerPlacementType = OverlayTriggerPlacementType;
OverlayTrigger.defaultProps = {
  rootClose: true
};
OverlayTrigger.propTypes = {
  children: _propTypes.default.element.isRequired,
  trigger: _propTypes.default.oneOfType([triggerType, _propTypes.default.arrayOf(triggerType)]),
  delay: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    show: _propTypes.default.number,
    hide: _propTypes.default.number
  })]),
  defaultShow: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  overlay: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element.isRequired]),
  popperConfig: _propTypes.default.object,
  placement: OverlayTriggerPlacementType
};